
import React from 'react'
import { Link } from 'react-router-dom'

interface WholesaleSplitV2Props {
  currentLang: 'zh' | 'en'
}

const WholesaleSplitV2: React.FC<WholesaleSplitV2Props> = ({ currentLang }) => {
  const t = currentLang === 'zh'
    ? {
        eyebrow: 'Wholesale',
        title: '為餐飲業者打造的批發合作',
        body1: '挑選一杯能為店裡加分的咖啡並不容易。我們從生豆採購、烘焙到風味建議，提供完整支援，讓你的店有獨一無二的咖啡風景。',
        body2: 'ONGU Studio 為合作夥伴打造的，不只是穩定的咖啡品質，更是能說出故事的每一杯飲品。從焙煎所到全台、世界各地，用心送達。',
        cta: 'Read more',
      }
    : {
        eyebrow: 'Wholesale',
        title: 'Wholesale partnerships for hospitality',
        body1: 'Choosing the right coffee for your venue is no small task. From green-bean sourcing to roast profile and flavour direction, we offer end-to-end support so your menu has a coffee voice of its own.',
        body2: 'For our partners we deliver more than consistent quality — every cup tells a story. From our roastery, to your shop, to the world.',
        cta: 'Read more',
      }

  return (
    <section className="relative bg-[#F5F5ED]">
      {/* Full-width image with overlay text on mobile, side-by-side on desktop */}
      <div className="grid grid-cols-1 md:grid-cols-2">
        {/* Image */}
        <div className="relative h-[50vh] md:h-[80vh]">
          <img
            src="https://file.lumi.new/p373839333138763776/SPF2016978766800949248.webp"
            alt={currentLang === 'zh' ? 'ONGU 批發' : 'ONGU wholesale'}
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>

        {/* Content */}
        <div className="flex flex-col justify-center bg-[#F5F5ED] px-6 py-16 md:px-16 md:py-20">
          <p
            className="mb-6 text-sm tracking-widest text-black/70"
            style={{ fontFamily: "'EB Garamond', serif", fontStyle: 'italic' }}
          >
            {t.eyebrow}
          </p>

          <h2
            className="mb-8 text-2xl text-black md:text-[28px]"
            style={{
              fontFamily: "'Noto Serif TC', 'EB Garamond', serif",
              fontWeight: 400,
              letterSpacing: '0.05em',
              lineHeight: 1.5,
            }}
          >
            {t.title}
          </h2>

          <p className="mb-5 text-[15px] leading-loose text-black/75" style={{ letterSpacing: '0.02em' }}>
            {t.body1}
          </p>
          <p className="mb-10 text-[15px] leading-loose text-black/75" style={{ letterSpacing: '0.02em' }}>
            {t.body2}
          </p>

          <Link
            to={`/${currentLang}/wholesale`}
            className="group inline-flex w-fit items-center text-sm tracking-widest text-black"
            style={{ fontFamily: "'EB Garamond', serif" }}
          >
            <span className="border-b border-black pb-1 transition-all duration-300 group-hover:tracking-[0.25em]">
              {t.cta}
            </span>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default WholesaleSplitV2
